<template>
  <Dialog
    v-model:visible="show"
    header="Permita o uso do microfone e câmera"
    :draggable="false"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '35vw' }"
    :modal="true"
    @hide="onCloseModalPermissionBrowser()"
  >
    <section>
      <p v-html="text"></p>
    </section>
  </Dialog>
</template>

<script lang="ts">
import { getUserFromStorage } from "@/utils/user-store.util";
import { EditUserService } from "@/views/EditUser/edit-user.service";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ModalPermissionBrowser",
  emits: ["onCloseModalPermissionBrowser"],
  computed: {
    userService(): EditUserService {
      return new EditUserService();
    },
    user(): any {
      return getUserFromStorage();
    },
  },
  props: {
    showModalPermissionBrowser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false as boolean,
      TIMER: "" as any,
      text: this.$t("labels.generic", {
        pt: `A Plataforma Homero precisa da sua
          permissão de <b>microfone</b> e <b>câmera</b> para que você possa
          <b>falar com o Homero</b> e habilitar a <b>detecção de atenção</b> para te
          ajudar a focar nos seus estudos.`,
        en: `A Plataforma Homero precisa da
          sua permissão de <b>microfone</b> e <b>câmera</b> para que você possa
          <b>falar com o Homero</b> e habilitar a detecção de atenção para te
          ajudar a focar nos seus estudos.`,
      }),
    };
  },
  mounted() {
    if (this.showModalPermissionBrowser) {
      this.show = this.showModalPermissionBrowser;
    } else {
      this.showPermissionBrowser();
    }
  },
  methods: {
    async showPermissionBrowser() {
      this.TIMER = setTimeout(() => {
        this.show = true;
      }, 1000);
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true,
        });

        this.show = false;
        window.clearTimeout(this.TIMER);
        stream.getTracks().forEach((track) => track.stop());
      } catch (err) {
          this.show = false;
          window.clearTimeout(this.TIMER);
      }
    },
    onCloseModalPermissionBrowser() {
      this.$emit("onCloseModalPermissionBrowser");
    },
  },
});
</script>
